import { forwardRef, memo } from 'react';
import type { ComponentPropsWithoutRef } from 'react';

import { cx } from '@/utils/cx';

import styles from './CategoryGroup.module.scss';

export type CategoryGroupProps = ComponentPropsWithoutRef<'div'>;

export const CategoryGroup = memo(
  forwardRef<HTMLDivElement, CategoryGroupProps>(({ children, className, ...rest }, ref) => (
    <div className={cx(styles.group, className)} data-core-ui-category-slot="group" ref={ref} {...rest}>
      {children}
    </div>
  )),
);

CategoryGroup.displayName = 'Category.Group';
